import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Button, Select } from 'antd';
import { createChallenge } from "../../features/challenge/challengeSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message as msg } from 'antd';
const { Option } = Select;

const CreateHoleOutPrize = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, creating, message, isCreateSuccess } = useSelector((state) => state.challenge);

  const onFinish = (data) => {
    if (data.prize_type === 'cash') {
      data.winning_item = null;
    } else {
      data.winning_price = 0;
    }
    dispatch(createChallenge(data));
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: 'error',
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: 'success',
        content: "Challenge created successfully",
      });
    }

    if (isCreateSuccess) {
      navigate('/admin/hole-out-prize');
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Challenge</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: 'day', status: '1', type: 'hole-out', prize_type: 'cash'}}
      >
      <Form.Item
        label="Challenge Name"
        name="name"
        rules={[{ required: true, message: 'Please input the challenge name!' }]}
      >
        <Input />
      </Form.Item>

      <div style={{ width: '100%' }}>
        <Form.Item style={{ marginBottom: 0 }}>
          <div style={{ display: 'flex', gap: 16 }}>
            <Form.Item
              label="Shot Type"
              name="shot_type"
              rules={[{ required: true, message: 'Please input the shot type!' }]}
              style={{ flex: 1 }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Distance"
              name="distance"
              rules={[{ required: true, message: 'Please input the distance!' }]}
              style={{ flex: 1 }}
            >
              <Input />
            </Form.Item>
          </div>
        </Form.Item>
      </div>
      
      <Form.Item
        label="Prize"
        name="prize"
        rules={[{ required: false, message: 'Please input the prize!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Points"
        name="points"
        rules={[{ required: false, message: 'Please input the points!' }]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
                      
      <Form.Item
        label="Entry Price"
        name="entry_price"
        rules={[{ required: false, message: 'Please input the entry price!' }]}
      >
        <InputNumber min={1} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="Order"
        name="order"
        rules={[{ required: true, message: 'Please input the order!' }]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true, message: 'Please select the status!' }]}
      >
        <Select>
          <Option value="1">Active</Option>
          <Option value="0">Inactive</Option>
        </Select>
      </Form.Item>
  
      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={creating}>
          {creating? 'Submitting...' : 'Submit'}
        </Button>
      </Form.Item>
      </Form>
    </div>
  );
};

export default CreateHoleOutPrize;
